import React, { createContext, useContext, useState, useEffect } from 'react';
import { useInitialState } from '../hooks/useInitialState';
import { useSiteId } from '../hooks/useSiteId';

const useFavoritesList = () => {
  const { idunUrl } = useInitialState();
  const siteId = useSiteId();
  const [favoriteIds, setFavoriteIds] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    fetch(`${idunUrl}/api/favorites?siteId=${siteId}`, { credentials: 'include' })
      .then((response) => (response.ok ? response.json() : []))
      .then((favorites) => setFavoriteIds(favorites || []))
      .catch(() => setFavoriteIds([]))
      .finally(() => setIsLoading(false));
  }, [idunUrl, siteId]);

  const setFavorite = (wvId, checked) => {
    setFavoriteIds((ids) => {
      if (checked) {
        return ids.includes(wvId) ? ids : [...ids, wvId];
      }
      return ids.filter((id) => id !== wvId);
    });
  };

  return { favoriteIds, isLoading, setFavorite };
};

const FavoritesContext = createContext();

const FavoritesProvider = ({ children }) => {
  const favoritesResult = useFavoritesList();
  return <FavoritesContext.Provider value={favoritesResult}>{children}</FavoritesContext.Provider>;
};

export const useFavoritesContext = () => useContext(FavoritesContext);
export default FavoritesProvider;
